import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Experience() {
  const skills = [
    // First Row
    [
      { src: "images/skills/html.webp", alt: "HTML" },
      { src: "images/skills/css.webp", alt: "CSS" },
      { src: "images/skills/js.webp", alt: "JavaScript" },
      { src: "images/skills/tailwind.png", alt: "Tailwind CSS" },
      { src: "images/skills/react.png", alt: "React" },
    ],
    // Second Row
    [
      { src: "images/skills/npm.png", alt: "npm" },
      { src: "images/skills/cursor.webp", alt: "Cursor" },
      { src: "images/skills/mysql.png", alt: "MySQL" },
      { src: "images/skills/supabase.png", alt: "Supabase" },
      { src: "images/skills/firebase.jpeg", alt: "Firebase" },
    ],
    // Third Row
    [
      { src: "images/skills/Python-AI--(1).webp", alt: "Python AI" },
      { src: "images/skills/laravel.png", alt: "Laravel" },
      { src: "images/skills/pytorch_seo.avif", alt: "PyTorch" },
      { src: "images/skills/node.png", alt: "Node.js" },
    ],
  ];
  return (
    <div className="text-center py-20 relative overflow-hidden">
      <motion.h2
        className="section-heading mb-12 text-4xl font-bold tracking-tight"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Built App With Modern Technologies
      </motion.h2>

      {skills.map((row, rowIndex) => (
        <motion.div
          key={rowIndex}
          className="flex flex-wrap justify-center gap-8 mt-10"
          initial="hidden"
          whileInView="visible"
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.1, delayChildren: 0.2 },
            },
          }}
        >
          {row.map((skill, index) => (
            <motion.img
              key={index}
              src={skill.src}
              alt={skill.alt}
              className="h-[100px] rounded-2xl shadow-lg p-3 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-slate-800 dark:to-slate-900 hover:scale-110 transition-transform duration-300"
              variants={{
                hidden: { opacity: 0, scale: 0.8, y: 20 },
                visible: { opacity: 1, scale: 1, y: 0 },
              }}
              transition={{
                type: "spring",
                stiffness: 120,
                damping: 10,
              }}
              whileHover={{
                scale: 1.15,
                rotate: 3,
                boxShadow:
                  "0px 0px 20px rgba(56, 189, 248, 0.4), 0px 0px 30px rgba(56, 189, 248, 0.2)",
              }}
            />
          ))}
        </motion.div>
      ))}

      {/* Floating animation background */}
      <motion.div
        className="absolute top-0 left-0 w-full h-full pointer-events-none"
        animate={{
          background: [
            "radial-gradient(circle at 20% 30%, rgba(56,189,248,0.05) 0%, transparent 60%)",
            "radial-gradient(circle at 80% 70%, rgba(168,85,247,0.05) 0%, transparent 60%)",
          ],
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      />
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]"></div>
    </div>
  );
}
